import { InventObject } from './InventObject.ts'
import type { InventoryMapObjectData, InventoryMapViewportType } from '@/widgets'
import { point } from '@turf/turf'

export default class InventObjectPoint extends InventObject {
  constructor(objectData: InventoryMapObjectData, objectType: InventoryMapViewportType) {
    super(objectData, objectType)

    this.feature = point(objectData.geometry.coordinates as [number, number], this.properties)
    this.geometry = this.feature.geometry
  }

  public transformCoords(coords: any) {
    return [coords]
  }

  public getLabelCoords(): number[] {
    return this.getMapCoords() as number[]
  }
}
